module.exports = __webpack_public_path__ + "media/components/country-flag/static/tz-4759e694508d13bd4202f58e11938331.svg";